import Script from "next/script";
import { useEffect, useRef } from "react";
import { PREFERRED_SOURCE_CTA_CLICKED } from "@/constants/amplitude";
import { SEO } from "@/constants/seo";
import { useAmplitude } from "@/utils/hooks/useAmplitude";
import { useArticleInfo } from "@/utils/hooks/useArticleContext";

const PreferredSourceCta = () => {
  const { logAmplitudeEvent } = useAmplitude();
  const {
    title: articleName = "",
    sport = "",
    sportSlug: competition = "",
  } = useArticleInfo();
  const badgeRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const badge = badgeRef.current;
    if (!badge) return;

    const handleClick = () => {
      logAmplitudeEvent(PREFERRED_SOURCE_CTA_CLICKED, {
        Module: "article_header",
        "Article Name": articleName,
        Competition: competition,
        Sport: sport,
      });
    };

    badge.addEventListener("click", handleClick);
    return () => badge.removeEventListener("click", handleClick);
  }, [articleName, competition, logAmplitudeEvent, sport]);

  return (
    <>
      <Script
        id="google-preferred-sources"
        strategy="afterInteractive"
        src={SEO.PREFERRED_SOURCE_SCRIPT}
        preferred-sources-control="manual"
        /**
         * google only scans for badge markers when init runs, and the ready
         * callback fires on every mount, so the badge also renders when readers
         * move between articles client side. google skips initialised markers
         */
        onReady={() => window.PREFERRED_SOURCE?.push((client) => client.init())}
      />
      <div
        ref={badgeRef}
        google-add-preferred-source-btn=""
        data-testid="preferred-source-cta"
      />
    </>
  );
};

export default PreferredSourceCta;
